<template>
  <div>
    <ClientHeader :client="client" />
    <div v-if="!shipments && loading">
      <v-skeleton-loader type="text" />
    </div>
    <div v-else v-for="(data, i) in shipments" :key="data.tracking_number">
      <h3>Tracking number: {{ data.tracking_number}} | Shipment type: {{data.shipment_type}}</h3>
      <v-stepper vertical v-model="data.tracking" flat>
        <template v-for="(status,index) in data.tracking"  v-if="checkForUnwantedStatus(status)">
          <v-stepper-step
            :step="index"
            :complete="status.phase === 0 || status.phase === -1"
            :complete-icon="status.phase === 0 ? 'mdi-progress-clock' : 'mdi-check'"
          >
            <span

              :class="status.phase === 0 ? 'font-weight-bold current' : null"
              class="text-uppercase"
              >{{ status.description }}</span
            >
            <small>{{ status.optionText }}</small>
          </v-stepper-step>
          <v-stepper-content :step="status.step"></v-stepper-content>
        </template>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import ClientsService from "@/services/clients.service";
import ClientHeader from "@/components/Client/ClientHeader.vue";
import ClientService from "@/services/clients.service";

export default {
  name: "client-shipment",
  components: { ClientHeader },
  data: () => ({
    shipments: null,
    clientId: null,
    client: null,
    loading: false,
  }),
  methods: {
    checkForUnwantedStatus(e){
      if(e.statusCode === "CANCELLED" || e.statusCode === "UNKNOW"){
        if (e.phase > 0) return false;
      }
      return true;
    },
    getShipments() {
      this.loading = true;
      ClientsService.getShipments(this.clientId)
        .then((res) => {
          this.shipments = res;
        })
        .finally(() => (this.loading = false));
    },
    getCurrentClient() {
      ClientService.getOneClient(this.clientId).then((res) => {
        this.client = res;
      });
    },
  },
  created() {
    this.clientId = this.$route.params.clientId;
    this.getCurrentClient();
    this.getShipments();
  },
};
</script>
